import { Component, inject } from "@angular/core"
import { LegacyCardComponent } from "./legacy-card.component"
import { LegacyCardsModalComponent } from "./legacy-cards-modal.component"
import { IntroService } from "../intro.service"
import { UiInheritDirective } from "ui-inherit"

@Component({
  imports: [
    LegacyCardComponent,
    LegacyCardsModalComponent,
    UiInheritDirective,
  ],
  providers: [],
  standalone: true,
  styles: [],
  template: `
    <div class="column gap-12 p-16 px-16 py-0 items-center">
      @for (data of cards(); track data.title) {
        <e2e-legacy-card [cardData]="data" inherit/>
      }
    </div>
    <e2e-legacy-cards-modal inherit/>
  `,
  selector: "e2e-legacy-cards",
})
export class LegacyCardsComponent {
  private introService = inject(IntroService)

  cards = this.introService.cards
}
